const StatusGroCustomerEnum = Object.freeze({
    NOVO_CLIENTE: 'NOVO CLIENTE',
    PENDENTE: 'PENDENTE',
    CONCLUIDO: 'CONCLUÍDO'
});

export default StatusGroCustomerEnum;